/* 臧霸（字宣高） */
import { L } from '../../core/kit.ts';
import { defineHero, hook } from '../define.ts';

export default defineHero({
  id: 'zangba', name: '臧霸', sub: '字宣高', faction: 'wei', role: '戰士', weapon: 'halberd',
  look: { beard: 'bushy', eye: 'fierce', skin: '#c8905e', fx: '#e8c25a', c: { plume: '#8a6a3a' } },
  skills: [
    ['泰山', 'spikes', '戟擊地面，岩刺向前推進，造成 {95/145/195/245} 傷害。'],
    ['豪俠', 'buff', '5 秒內攻擊 +{15/25/35/45}，普攻吸血 20%。', { x: { k: 'buff', atk: [15, 25, 35, 45], ls: 20, dur: 5 } }],
    ['青徐之主', 'passive', '離開戰鬥狀態（沒有造成或受到傷害）2.5 秒後，移動速度 +{5/8/10/13}。', { pv: {}, sig: 'oocMs', msAdd: [5, 8, 10, 13], after: 2.5 }],
    ['泰山壓頂', 'slam', '躍起重砸，範圍 {320/470/620} 傷害並暈眩 1 秒。'],
  ],
  // 被動與專屬效果：hook(時間點, 順位, 處理)（時間點一覽見 core/hooks.ts）
  hooks: [
    // 青徐之主：離開戰鬥 2.5 秒後移速 +5
    hook('step.hero.early', 10, function (u, dt) {
      const oi = u.spec.skills ? u.spec.skills.findIndex((s) => s.sig === 'oocMs') : -1;
      if (oi >= 0) { const sk = u.spec.skills[oi]; u.msFlat = u.skillLv[oi] && this.t - (u.combatT == null ? -99 : u.combatT) >= sk.after ? L(sk.msAdd, u.skillLv[oi]) : 0; }
    }),
  ],
});
